"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanClient = void 0;
var opa_wasm_1 = require("@open-policy-agent/opa-wasm");
var constants_1 = require("./constants");
var UserBundleManager_1 = require("./UserBundleManager");
var utils_1 = require("./utils");
var regoPolicyWasm_1 = require("./regoPolicyWasm");
var mitt_1 = __importDefault(require("mitt"));
var CanClientError_1 = require("./CanClientError");
var CanClient = /** @class */ (function () {
    function CanClient(config) {
        var _this = this;
        this._config = config;
        this._eventEmitter = mitt_1.default();
        this._userBundleManager = new UserBundleManager_1.UserBundleManager({
            loadData: config.loadData,
            ttl: config.ttl,
            setDataHandler: function (data) {
                _this._policyAgent.setData(data);
            },
        });
        // start loading in async mode and emit 'ready' event
        // when initialized or 'error' event if something fails to load
        opa_wasm_1.loadPolicy(regoPolicyWasm_1.wasmByteArray)
            .then(function (policy) { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._policyAgent = policy;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._userBundleManager.getData()];
                    case 2:
                        _a.sent();
                        this._eventEmitter.emit("ready");
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this._eventEmitter.emit("error", utils_1.constructEventError(CanClientError_1.CanClientErrorCodes.LOADING_WASM_POLICY, error_1));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })
            .catch(function (error) {
            _this._eventEmitter.emit("error", utils_1.constructEventError(CanClientError_1.CanClientErrorCodes.LOADING_WASM_POLICY, error));
        });
    }
    CanClient.prototype.on = function (eventType, cb) {
        this._eventEmitter.on(eventType, cb);
    };
    CanClient.prototype.off = function (eventType, cb) {
        this._eventEmitter.off(eventType, cb);
    };
    CanClient.prototype.reset = function () {
        var _a;
        (_a = this._policyAgent) === null || _a === void 0 ? void 0 : _a.setData({});
        this._userBundleManager.clear();
        this._eventEmitter.emit("reset");
    };
    CanClient.prototype.reload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._userBundleManager.getData()];
                    case 1:
                        _a.sent();
                        this._eventEmitter.emit("reload");
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        this._eventEmitter.emit("error", utils_1.constructEventError(CanClientError_1.CanClientErrorCodes.RESETTING_CLIENT, error_2));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CanClient.prototype.evaluate = function (evaluationEntrypoint, evaluationData, isCanNot) {
        return __awaiter(this, void 0, void 0, function () {
            var _promise;
            var _this = this;
            return __generator(this, function (_a) {
                _promise = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                    var expirationTimeLeft, error_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                expirationTimeLeft = this._userBundleManager.getExpirationTimeLeft();
                                if (!!expirationTimeLeft) return [3 /*break*/, 5];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this._userBundleManager.getData()];
                            case 2:
                                _a.sent();
                                resolve(utils_1.parseEvaluationResult((isCanNot &&
                                    this._policyAgent.evaluate(evaluationData, evaluationEntrypoint) === false) ||
                                    this._policyAgent.evaluate(evaluationData, evaluationEntrypoint)));
                                return [3 /*break*/, 4];
                            case 3:
                                error_3 = _a.sent();
                                this._eventEmitter.emit("error", utils_1.constructEventError(this._policyAgent
                                    ? CanClientError_1.CanClientErrorCodes.REFETCHING_DATA
                                    : CanClientError_1.CanClientErrorCodes.EVALUATING_INPUT, error_3));
                                this._policyAgent
                                    ? resolve(utils_1.parseEvaluationResult((isCanNot &&
                                        this._policyAgent.evaluate(evaluationData, evaluationEntrypoint) === false) ||
                                        this._policyAgent.evaluate(evaluationData, evaluationEntrypoint)))
                                    : reject(new CanClientError_1.CanClientError({
                                        message: error_3,
                                        code: CanClientError_1.CanClientErrorCodes.EVALUATING_INPUT,
                                    }));
                                return [3 /*break*/, 4];
                            case 4: return [3 /*break*/, 6];
                            case 5:
                                resolve(utils_1.parseEvaluationResult(this._policyAgent.evaluate(evaluationData, evaluationEntrypoint)));
                                _a.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/, _promise];
            });
        });
    };
    CanClient.prototype.can = function (permission) {
        return this.evaluate(constants_1.policyEntrypoints.can, permission);
    };
    CanClient.prototype.canNot = function (permission) {
        return this.evaluate(constants_1.policyEntrypoints.can, permission, true);
    };
    CanClient.prototype.canAll = function (permissions) {
        return this.evaluate(constants_1.policyEntrypoints.canAll, permissions);
    };
    CanClient.prototype.canAny = function (permissions) {
        return this.evaluate(constants_1.policyEntrypoints.canAny, permissions);
    };
    return CanClient;
}());
exports.CanClient = CanClient;
//# sourceMappingURL=CanClient.js.map